import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/omit'; // 大小以及颜色样式

function sizeAndColor(props) {
  var size = props.size,
      style = props.style,
      color = props.color;
  var styles = {};

  if (size) {
    var realSize = typeof size === 'number' ? "".concat(size, "px") : size;
    styles = {
      height: realSize,
      width: realSize,
      fontSize: realSize
    };
  }

  if (color) {
    styles.color = color;
  }

  return _Object$assign(_Object$assign({}, styles), style);
} // icon图标样式


function iconClassName(props) {
  var nameClass = props.name === 'loading' ? "roo-icon-".concat(props.name, " ani-spin") : "roo-icon-".concat(props.name);
  return classNames('roo-icon', nameClass, props.className);
}

var Icon = function Icon(_a) {
  var children = _a.children,
      restProps = __rest(_a, ["children"]);

  var otherProps = omit(restProps, ['size', 'name', 'color']);
  return /*#__PURE__*/React.createElement("i", _Object$assign({}, otherProps, {
    className: iconClassName(restProps),
    style: sizeAndColor(restProps)
  }), children);
};

Icon.defaultProps = {
  size: undefined,
  color: undefined,
  className: undefined,
  style: undefined
};
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Icon;